// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1NHue","buttons":"PendingPaymentAlert_buttons__1iL6v"};